import { METADATA } from '@flexo/reducers';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const ENV: any = (import.meta as any).env;

/**
 * UserManagementResolver
 *
 * Fetches admin users from the catalog API for the admin-management page.
 * Dispatches two parallel paginated requests: one for active, one for invited.
 *
 * API: GET /community/catalog/v1_4/organization/{organizationId}/users
 */
export const UserManagementResolver = () => {
  const dispatch = useDispatch();

  // Get organization ID from user state (from JWT claims)
  const user = useSelector((state: any) => state.user);
  const organizationId = user?.organizationId || user?.flexo_org_id;

  async function init() {
    const orgId = ENV.VITE_APP_ORG_ID;

    // Paginated fetches — active and invited in parallel
    dispatch(
      METADATA.SetAdminsPaginatedAsync({
        dispatch,
        organizationId: orgId,
        status: 'active',
        page: 1,
        pageSize: 50,
        sortBy: 'user',
        sortDir: 'asc',
      }) as any
    );
    dispatch(
      METADATA.SetAdminsPaginatedAsync({
        dispatch,
        organizationId: orgId,
        status: 'invited',
        page: 1,
        pageSize: 50,
        sortBy: 'invited',
        sortDir: 'desc',
      }) as any
    );
  }

  useEffect(() => {
    init();
  }, [organizationId]);

  return <></>;
};

export default UserManagementResolver;
